import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import {
  Button,
  DropDownButton,
  DropDownButtonItem,
} from "@progress/kendo-react-buttons";
import { FiEdit } from "react-icons/fi";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { MdDelete, MdPrint } from "react-icons/md";

import { useLocation, useNavigate } from "react-router-dom";
import {
  checkAcessRights,
  convertHtmlToWhatsAppFormat,
  copyHtmlToClipboard,
} from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  PRINT_ACCESS,
} from "../../_contstants/common";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import { FaEye } from "react-icons/fa";
import IconComponent from "../../components/common/IconComponent";
import AlertBox from "../../components/common/AlertBox";
import { Tooltip } from "@progress/kendo-react-tooltip";
import {
  deleteVisaQuotation,
  getAllVisaQuotations,
  getVisaQuotationHistoryByParentID,
  getVisaQuotationMessageForCopy,
} from "./services/quotation.services";
import {
  clearVisaQuotationFilterDetails,
  clearVisaQuotationID,
  setVisaQuotationID,
} from "./quotationSlice";
import VisaQuotationFilter from "./VisaQuotationFilter";
import { ErrorToast, SuccessToast } from "../../components/toast/Toasts";
import { clipboardIcon } from "@progress/kendo-svg-icons";

const VisaQuotationGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const isEditBtnRef = useRef<any>(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // const LeadID = location.state?.LeadID;
  // const ContactID = location.state?.ContactID;
  // const InquiryID = location.state?.InquiryID;
  // const isAddAccess = checkAcessRights("/fitbooking", INSERT_ACCESS);
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);
  const VisaQuotationList = useAppSelector(
    (state) => state.quotation.VisaQuotationList,
  );
  const loading = useAppSelector((state) => state.quotation.loading);
  const messageLoading = useAppSelector(
    (state) => state.quotation.messageLoading,
  );
  const FITLoading = useAppSelector((state) => state.FITBooking.loading);
  const VisaQuotationFilterDetails = useAppSelector(
    (state) => state.quotation.VisaQuotationFilterDetails,
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  useEffect(() => {
    // const matchFilter = (id: any, filterId: any) =>
    //   (!id && !filterId) || (id && filterId);

    // const hasMatchingFilterID =
    //   matchFilter(ContactID, VisaQuotationFilterDetails?.filterContactID) &&
    //   matchFilter(InquiryID, VisaQuotationFilterDetails?.filterInquiryID) &&
    //   matchFilter(LeadID, VisaQuotationFilterDetails?.filterLeadID);

    // if (hasMatchingFilterID) {
    dispatch(
      getAllVisaQuotations({
        ...VisaQuotationFilterDetails,
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      }),
    );
    // }
  }, [VisaQuotationFilterDetails, currentPage, pageLimit]);

  useEffect(() => {
    return () => {
      if (!isEditBtnRef.current) {
        dispatch(setCurrentPage(0));
        dispatch(setPageLimit(50));
        dispatch(clearVisaQuotationFilterDetails());
      }
    };
  }, []);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  // const handleAddTourBooking = async (data: any) => {
  //   if (data?.ID) {
  //     dispatch(openDialog("bookingConfirmationDialog"));
  //     dispatch(setVisaQuotationID(data?.ID));
  //   }
  // };

  const MyEditCommandCell = (props: any) => {
    const handleEdit = (item: any) => {
      navigate("/quotation/visa/edit", {
        state: {
          VisaQuotationID: item?.ID,
          SectorID: item?.SectorID,
        },
      });
    };
    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteVisaQuotation"));
      dispatch(setVisaQuotationID(ID));
    };

    // const handleSendEmail = async (ID: number) => {
    //   if (ID) {
    //     dispatch(openDialog("emailConfirmationDialog"));
    //     dispatch(setVisaQuotationID(ID));
    //   }
    // };

    const handlePrint = async (VisaQuot_GUID: number) => {
      if (VisaQuot_GUID) {
        window.open(`/quotation/visa/view/${VisaQuot_GUID}`);
      }
    };

    const handleCopyMessage = async (ID: number, type = "email") => {
      try {
        if (ID) {
          const res = await dispatch(
            getVisaQuotationMessageForCopy({
              ID: ID,
              MessageType: type,
            }),
          );

          const htmlContent = res?.payload?.WhatsAppMessage || "";

          if (htmlContent) {
            let textToCopy = htmlContent;

            if (type === "whatsapp") {
              // Convert HTML to WhatsApp formatted text
              textToCopy = convertHtmlToWhatsAppFormat(htmlContent);
            } else if (type === "email") {
              // For email, copy as HTML with formatting
              await copyHtmlToClipboard(htmlContent);
              SuccessToast(
                `Message copied with formatting! You can now paste it in ${type}`,
              );
              return;
            }

            // Copy to clipboard
            await navigator.clipboard.writeText(textToCopy);

            SuccessToast(
              `Message copied to clipboard! You can now paste it in ${type}`,
            );
          } else {
            ErrorToast("No message found to copy.");
          }
        }
      } catch (error) {
        console.error("Failed to copy message:", error);
        alert("Failed to copy message. Please try again.");
      }
    };

    const handleCopyItemClick = (event: any, ID: number) => {
      const clickedItem = event?.item?.text;

      if (clickedItem === "Whatsapp") {
        handleCopyMessage(ID, "whatsapp");
      } else if (clickedItem === "Email") {
        handleCopyMessage(ID, "email");
      }
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            onClick={() => {
              isEditBtnRef.current = true;
              handleEdit(props.dataItem);
            }}
            icon={FiEdit}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )}
        {/* {isAddAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Generate FIT Booking"
            onClick={() => handleAddTourBooking(props.dataItem)}
            icon={FaBookMedical}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )} */}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            className="color-red"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
            icon={MdDelete}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        {/* <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Send Email"
          themeColor="success"
          onClick={() => handleSendEmail(props.dataItem.ID)}
          icon={TbMailShare}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        /> */}
        {isPrintAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Print"
            themeColor="dark"
            onClick={() => handlePrint(props.dataItem.VisaQuot_GUID)}
            icon={MdPrint}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        <Tooltip anchorElement="target" position="top" parentTitle={true}>
          <DropDownButton
            svgIcon={clipboardIcon}
            className="drop-down-btn"
            fillMode={"flat"}
            title="Copy Message"
            themeColor={"primary"}
            onItemClick={(event) =>
              handleCopyItemClick(event, props.dataItem.ID)
            }
            popupSettings={{
              anchorAlign: { horizontal: "right", vertical: "bottom" },
              popupAlign: { horizontal: "center", vertical: "top" },
            }}
          >
            <DropDownButtonItem text="Whatsapp" />
            <DropDownButtonItem text="Email" />
          </DropDownButton>
        </Tooltip>
      </td>
    );
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 10 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props.tdProps} />
  );

  // const ListingButtonCell = (props: any) => {
  //   const handleBookings = (ID: number) => {
  //     navigate("/tourbooking", { state: { VisaQuotationID: ID } });
  //   };
  //   const handleFITBookings = (ID: number) => {
  //     navigate("/fitbooking", { state: { VisaQuotationID: ID } });
  //   };

  //   return (
  //     <td
  //       {...props.tdProps}
  //       className={`action-td ${props.className}`}
  //       style={{ ...props.tdProps.style }}
  //     >
  //       {false && (
  //         <IconButton
  //           type="button"
  //           fillMode="flat"
  //           size="small"
  //           title="Tour Bookings"
  //           themeColor="tertiary"
  //           onClick={() => handleBookings(props.dataItem.ID)}
  //           icon={BsBookmarkPlusFill}
  //           iconClassName="absolute-position"
  //           iconStyle={{ fontSize: "20px" }}
  //         />
  //       )}
  //       <IconButton
  //         type="button"
  //         fillMode="flat"
  //         size="small"
  //         title="FIT Bookings"
  //         themeColor="dark"
  //         onClick={() => handleFITBookings(props.dataItem.ID)}
  //         icon={RiBookMarkedLine}
  //         iconClassName="absolute-position"
  //         iconStyle={{ fontSize: "20px" }}
  //       />
  //     </td>
  //   );
  // };

  const handleChildView = async (props: any) => {
    const res = await dispatch(
      getVisaQuotationHistoryByParentID(props?.ParentID),
    );
    if (res.meta?.requestStatus === "fulfilled") {
      dispatch(openDialog("childVisaQuotationHistories"));
    }
  };

  return (
    <>
      <ChildVisaQuotationDialog />
      <DeleteVisaQuotationDialog />
      {(loading || FITLoading || messageLoading) && (
        <LoadingPanel gridRef={gridRef} />
      )}
      <div
        style={{
          position: "relative",
          marginBottom: "10px",
          padding: "10px",
          border: "1px solid lightgray",
          borderRadius: "5px",
          boxShadow: "0 0 10px gainsboro",
        }}
      >
        <VisaQuotationFilter />
      </div>
      <KendoGrid
        style={{ maxHeight: "calc(100vh - 265px)" }}
        className="responsive-table"
        filterable={false}
        data={VisaQuotationList}
        total={VisaQuotationList[0]?.ItemCount || VisaQuotationList?.length}
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [5, 10, 50, 100, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          field="QuotationNo"
          title="Quotation No."
          width={130}
          cells={{
            data: (props: any) => (
              <td>
                {isEditAccess ? (
                  <div className="d-flex gap-2 align-items-center">
                    <div
                      className="hoverableName"
                      onClick={() =>
                        navigate("/quotation/visa/edit", {
                          state: {
                            VisaQuotationID: props.dataItem?.ID,
                            SectorID: props.dataItem?.SectorID,
                          },
                        })
                      }
                    >
                      {props.dataItem?.QuotationNo}
                    </div>
                    {props.dataItem?.ParentID &&
                    props.dataItem?.ParentID > 0 ? (
                      <div onClick={() => handleChildView(props.dataItem)}>
                        <Tooltip
                          anchorElement="target"
                          position="top"
                          parentTitle={true}
                        >
                          <IconComponent
                            icon={FaEye}
                            title="View History"
                            style={{
                              color: "green",
                              fontSize: 18,
                              cursor: "pointer",
                            }}
                          />
                        </Tooltip>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  <div className="normalName">
                    {props.dataItem?.QuotationNo}
                    {props.dataItem?.ParentID &&
                    props.dataItem?.ParentID > 0 ? (
                      <div onClick={() => handleChildView(props.dataItem)}>
                        <IconComponent
                          icon={FaEye}
                          style={{
                            color: "green",
                            fontSize: 18,
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </td>
            ),
          }}
        />
        <Column
          field="CreatedOn"
          title="Quotation Date"
          width={120}
          cells={{
            data: (props: any) => <td>{props.dataItem?.CreatedOn}</td>,
          }}
        />
        <Column
          field="FirstName"
          title="Customer Name"
          width={150}
          cells={{
            data: (props: any) => (
              <td>
                {props.dataItem?.FirstName} {props.dataItem?.LastName}
              </td>
            ),
          }}
        />
        <Column
          field="MobileNo"
          title="Mobile No"
          width={140}
          cells={{
            data: (props: any) => <td>{props.dataItem?.MobileNo}</td>,
          }}
        />
        <Column
          field="EmailID"
          title="Email ID"
          width={250}
          cells={{
            data: (props: any) => <td>{props.dataItem?.EmailID}</td>,
          }}
        />
        <Column
          field="VisaCategory"
          title="Visa Category"
          width={120}
          cells={{
            data: (props: any) => <td>{props.dataItem?.VisaCategory}</td>,
          }}
        />
        <Column
          field="PassportNumber"
          title="Passport No."
          width={120}
          cells={{
            data: (props: any) => <td>{props.dataItem?.PassportNumber}</td>,
          }}
        />
        <Column
          field="TravelDate"
          title="Travel Date"
          width={150}
          cells={{
            data: (props: any) => <td>{props.dataItem?.TravelDate}</td>,
          }}
        />
        <Column
          field="Duration"
          title="Duration"
          width={150}
          cells={{
            data: (props: any) => <td>{props.dataItem?.Duration || 0} Days</td>,
          }}
        />
        <Column
          field="TravelPurpose"
          title="Travel Purpose"
          width={150}
          cells={{
            data: (props: any) => <td>{props.dataItem?.TravelPurpose}</td>,
          }}
        />
        {/* <Column
          field="ID"
          title="Details"
          cells={{ data: ListingButtonCell }}
          width={"110px"}
          filterable={false}
          locked={true}
        /> */}
        {/* {(isEditAccess || isDeleteAccess || isAddAccess) && ( */}
        <Column
          field="ID"
          title="Actions"
          cells={{ data: MyEditCommandCell }}
          width={"170px"}
          filterable={false}
          locked={true}
        />
        {/* )} */}
      </KendoGrid>
    </>
  );
};

const DeleteVisaQuotationDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const VisaQuotationID = useAppSelector(
    (state) => state.quotation.VisaQuotationID,
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const VisaQuotationFilterDetails = useAppSelector(
    (state) => state.quotation.VisaQuotationFilterDetails,
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteVisaQuotation(ID));

      if (response.meta.requestStatus === "fulfilled") {
        dispatch(
          getAllVisaQuotations({
            ...VisaQuotationFilterDetails,
            limit: +pageLimit,
            skip: +currentPage * +pageLimit,
          }),
        );
        dispatch(closeDialog());
        dispatch(clearVisaQuotationID());
      } else {
        dispatch(
          getAllVisaQuotations({
            ...VisaQuotationFilterDetails,
            limit: +pageLimit,
            skip: +currentPage * +pageLimit,
          }),
        );
        dispatch(closeDialog());
        dispatch(clearVisaQuotationID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteVisaQuotation" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Visa Quotation"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Visa Quotation?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(VisaQuotationID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

// const BookingConfirmationDialog: React.FC = () => {
//   const dispatch = useAppDispatch();
//   const navigate = useNavigate();
//   const VisaQuotationID = useAppSelector(
//     (state) => state.quotation.VisaQuotationID
//   );
//   const loading = useAppSelector((state) => state.FITBooking.loading);
//   const dialogName = useAppSelector((state) => state.dialog.dialogName);
//   const gridRef = useRef<any>(null);

//   const handleConfirm = async (ID: number | null) => {
//     if (ID) {
//       const res = await dispatch(
//         generateFITBookingByQuotationID({ VisaQuotationID: ID })
//       );
//       if (res.meta.requestStatus === "fulfilled") {
//         dispatch(setCurrentPage(0));
//         dispatch(setPageLimit(50));
//         dispatch(closeDialog());
//         navigate("/fitbooking");
//       }
//     }
//   };

//   return (
//     <>
//       {dialogName === "bookingConfirmationDialog" && (
//         <AppDialog>
//           <>
//             {loading && <LoadingPanel gridRef={gridRef} />}
//             <Typography.h5>{"Booking Confirmation"}</Typography.h5>
//             <GridLayout>
//               <GridLayoutItem>
//                 <Typography.p>
//                   Are you sure you want to generate this Booking?
//                 </Typography.p>
//               </GridLayoutItem>
//               <GridLayoutItem
//                 style={{
//                   display: "flex",
//                   justifyContent: "end",
//                 }}
//               >
//                 <DialogCloseButton themeColor="primary" />
//                 <Button
//                   fillMode={"solid"}
//                   themeColor={"primary"}
//                   onClick={() => handleConfirm(VisaQuotationID)}
//                   type="button"
//                 >
//                   Confirm
//                 </Button>
//               </GridLayoutItem>
//             </GridLayout>
//           </>
//         </AppDialog>
//       )}
//     </>
//   );
// };

// const EmailConfirmationDialog: React.FC = () => {
//   // const dispatch = useAppDispatch();
//   const VisaQuotationID = useAppSelector(
//     (state) => state.quotation.VisaQuotationID
//   );
//   const loading = useAppSelector((state) => state.quotation.loading);
//   const dialogName = useAppSelector((state) => state.dialog.dialogName);
//   const gridRef = useRef<any>(null);

//   const handleConfirm = async (ID: number | null) => {
//     if (ID) {
//       // const res = await dispatch(sendQuotationByEmail(+ID));
//       // if (res.meta.requestStatus === "fulfilled") {
//       //   dispatch(closeDialog());
//       // }
//     }
//   };

//   return (
//     <>
//       {dialogName === "emailConfirmationDialog" && (
//         <AppDialog>
//           <>
//             {loading && <LoadingPanel gridRef={gridRef} />}
//             <Typography.h5>{"Email Confirmation"}</Typography.h5>
//             <GridLayout>
//               <GridLayoutItem>
//                 <Typography.p>
//                   Are you sure you want to send Email?
//                 </Typography.p>
//               </GridLayoutItem>
//               <GridLayoutItem
//                 style={{
//                   display: "flex",
//                   justifyContent: "end",
//                 }}
//               >
//                 <DialogCloseButton themeColor="primary" />
//                 <Button
//                   fillMode={"solid"}
//                   themeColor={"primary"}
//                   onClick={() => handleConfirm(VisaQuotationID)}
//                   type="button"
//                 >
//                   Confirm
//                 </Button>
//               </GridLayoutItem>
//             </GridLayout>
//           </>
//         </AppDialog>
//       )}
//     </>
//   );
// };

const ChildVisaQuotationDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const gridRef = useRef<any>(null);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const VisaQuotationHistoryList = useAppSelector(
    (state) => state.quotation.VisaQuotationHistoryList,
  );
  console.log("VisaQuotationHistoryList", VisaQuotationHistoryList);
  const loading = useAppSelector((state) => state.quotation.loading);
  // const isAddAccess = checkAcessRights("/fitbooking", INSERT_ACCESS);
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);

  useEffect(() => {
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  const MyEditCommandCell = (data: any) => {
    const handleEdit = (item: any) => {
      navigate("/quotation/visa/edit", {
        state: {
          VisaQuotationID: item?.ID,
          SectorID: item?.SectorID,
        },
      });
    };

    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteVisaQuotation"));
      dispatch(setVisaQuotationID(ID));
    };

    // const handleAddTourBooking = async (data: any) => {
    //   if (data?.ID) {
    //     dispatch(openDialog("bookingConfirmationDialog"));
    //     dispatch(setVisaQuotationID(data?.ID));
    //   }
    // };

    // const handleSendEmail = async (ID: number) => {
    //   if (ID) {
    //     dispatch(openDialog("emailConfirmationDialog"));
    //     dispatch(setVisaQuotationID(ID));
    //   }
    // };

    const handlePrint = async (VisaQuot_GUID: string) => {
      if (VisaQuot_GUID) {
        window.open(`/quotation/visa/view/${VisaQuot_GUID}`);
      }
    };

    const handleCopyMessage = async (ID: number, type = "email") => {
      try {
        if (ID) {
          const res = await dispatch(
            getVisaQuotationMessageForCopy({
              ID: ID,
              MessageType: type,
            }),
          );

          const htmlContent = res?.payload?.WhatsAppMessage || "";

          if (htmlContent) {
            let textToCopy = htmlContent;

            if (type === "whatsapp") {
              // Convert HTML to WhatsApp formatted text
              textToCopy = convertHtmlToWhatsAppFormat(htmlContent);
            } else if (type === "email") {
              // For email, copy as HTML with formatting
              await copyHtmlToClipboard(htmlContent);
              SuccessToast(
                `Message copied with formatting! You can now paste it in ${type}`,
              );
              return;
            }

            // Copy to clipboard
            await navigator.clipboard.writeText(textToCopy);

            SuccessToast(
              `Message copied to clipboard! You can now paste it in ${type}`,
            );
          } else {
            ErrorToast("No message found to copy.");
          }
        }
      } catch (error) {
        console.error("Failed to copy message:", error);
        alert("Failed to copy message. Please try again.");
      }
    };

    const handleCopyItemClick = (event: any, ID: number) => {
      const clickedItem = event?.item?.text;

      if (clickedItem === "Whatsapp") {
        handleCopyMessage(ID, "whatsapp");
      } else if (clickedItem === "Email") {
        handleCopyMessage(ID, "email");
      }
    };

    return (
      <td className="action-td">
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            onClick={() => {
              // isEditBtnRef.current = true;
              handleEdit(data?.item);
            }}
            icon={FiEdit}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )}
        {/* {isAddAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Generate FIT Booking"
            onClick={() => handleAddTourBooking(data?.item)}
            icon={FaBookMedical}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )} */}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            className="color-red"
            onClick={() => handleOpenDeleteDialog(data?.item?.ID)}
            icon={MdDelete}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        {/* <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Send Email"
          themeColor="success"
          onClick={() => handleSendEmail(data?.item?.ID)}
          icon={TbMailShare}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        /> */}
        {isPrintAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Print"
            themeColor="dark"
            onClick={() => handlePrint(data?.item?.VisaQuot_GUID)}
            icon={MdPrint}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        <Tooltip anchorElement="target" position="top" parentTitle={true}>
          <DropDownButton
            svgIcon={clipboardIcon}
            className="drop-down-btn"
            fillMode={"flat"}
            title="Copy Message"
            themeColor={"primary"}
            onItemClick={(event) => handleCopyItemClick(event, data?.item?.ID)}
            popupSettings={{
              anchorAlign: { horizontal: "right", vertical: "bottom" },
              popupAlign: { horizontal: "center", vertical: "top" },
            }}
          >
            <DropDownButtonItem text="Whatsapp" />
            <DropDownButtonItem text="Email" />
          </DropDownButton>
        </Tooltip>
      </td>
    );
  };

  // const ListingButtonCell = (data: any) => {
  //   const handleBookings = (ID: number) => {
  //     navigate("/tourbooking", { state: { VisaQuotationID: ID } });
  //   };
  //   const handleFITBookings = (ID: number) => {
  //     navigate("/fitbooking", { state: { VisaQuotationID: ID } });
  //   };

  //   return (
  //     <td className={`action-td`}>
  //       {false && (
  //         <IconButton
  //           type="button"
  //           fillMode="flat"
  //           size="small"
  //           title="Tour Bookings"
  //           themeColor="tertiary"
  //           onClick={() => handleBookings(data?.item?.ID)}
  //           icon={BsBookmarkPlusFill}
  //           iconClassName="absolute-position"
  //           iconStyle={{ fontSize: "20px" }}
  //         />
  //       )}
  //       <IconButton
  //         type="button"
  //         fillMode="flat"
  //         size="small"
  //         title="FIT Bookings"
  //         themeColor="dark"
  //         onClick={() => handleFITBookings(data?.item?.ID)}
  //         icon={RiBookMarkedLine}
  //         iconClassName="absolute-position"
  //         iconStyle={{ fontSize: "20px" }}
  //       />
  //     </td>
  //   );
  // };

  return (
    <>
      {dialogName === "childVisaQuotationHistories" && (
        <AppDialog>
          <>
            <Typography.h5>{"Visa Quotation History"}</Typography.h5>
            <GridLayout style={{ position: "relative" }}>
              {loading && <LoadingPanel gridRef={gridRef} />}
              <GridLayoutItem
                style={{
                  maxHeight: "calc(100vh - 160px)",
                  overflow: "auto",
                  scrollbarWidth: "thin",
                  borderBottom: "1px solid lightgray",
                }}
              >
                {VisaQuotationHistoryList &&
                VisaQuotationHistoryList?.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-bordered mb-0">
                      <thead>
                        <tr style={{ whiteSpace: "nowrap" }}>
                          <th style={{ background: "black", color: "white" }}>
                            Quotation No
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Date
                          </th>
                          <th
                            style={{
                              background: "black",
                              color: "white",
                              minWidth: 150,
                            }}
                          >
                            Name
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Mobile No.
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Email ID
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Created By
                          </th>
                          {/* <th
                            style={{
                              background: "black",
                              color: "white",
                              minWidth: 90,
                            }}
                          >
                            Details
                          </th> */}
                          <th
                            style={{
                              background: "black",
                              color: "white",
                              minWidth: 160,
                            }}
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {VisaQuotationHistoryList?.map(
                          (item: any, index: number) => (
                            <tr key={index}>
                              <td>
                                {isEditAccess ? (
                                  <div className="d-flex gap-2 align-items-center">
                                    <div
                                      className="hoverableName"
                                      onClick={() =>
                                        navigate("/quotation/visa/edit", {
                                          state: {
                                            VisaQuotationID: item?.ID,
                                            SectorID: item?.SectorID,
                                          },
                                        })
                                      }
                                    >
                                      {item?.QuotationNo}
                                    </div>
                                  </div>
                                ) : (
                                  <div className="normalName">
                                    {item?.QuotationNo}
                                  </div>
                                )}
                              </td>
                              <td>{item?.CreatedOn}</td>
                              <td>
                                <div className="fw-600">
                                  {item?.FirstName} {item?.LastName}
                                </div>
                              </td>
                              <td>{item?.MobileNo}</td>
                              <td>{item?.EmailID}</td>
                              <td>{item?.CreatedByName}</td>
                              {/* <td className="d-flex justify-content-center">
                                <ListingButtonCell item={item} />
                              </td> */}
                              <td>
                                <MyEditCommandCell item={item} />
                              </td>
                            </tr>
                          ),
                        )}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <AlertBox style={{ marginBottom: 10 }} />
                )}
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginTop: 20,
                }}
              >
                <DialogCloseButton themeColor="error" />
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default VisaQuotationGridComponent;
